<template>
    <!-- 支付弹窗 -->
    <el-dialog
        title="支付弹窗"
        :visible.sync="dialogVisible"
        width="650px"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        append-to-body
        top="8vh"
    >
        <div class="pay-dialog-container lh15">
            <div class="tc">
                <p>扫一扫付款（元）</p>
                <p class="money">￥{{ option.Cost }}</p>
                <div class="money-img">
                    <img :src="option.payImg" alt="" />
                    <img
                        v-if="option.payImg"
                        src="http://oss.fjdaze.com/tools/dzPopup/icon/payment.png"
                        alt=""
                        class="zhifubao"
                    />
                </div>
                <img class="img-tip" src="http://oss.fjdaze.com/tools/dzPopup/icon/scan.png" alt="" />
                <p style="margin: 20px 0; text-decoration: underline">首次使用请下载手机支付宝</p>
            </div>
        </div>
    </el-dialog>
</template>
<script>
export default {
    name: 'PayDialog',
    data() {
        return {
            dialogVisible: false,
            option: {
                Cost: '',
                payImg: '',
            },
        };
    },
    methods: {
        show(data) {
            Object.assign(this.option, data);
            this.dialogVisible = true;
        },
        close() {
            this.dialogVisible = false;
            this.option = {
                Cost: '',
                payImg: '',
            };
        },
    },
};
</script>
<style lang="scss">
.pay-dialog-container {
    position: relative;
    > div {
        width: 270px;
        margin: 0 auto;
        .money {
            font-size: 20px;
            color: #ff0101;
            text-align: center;
            font-weight: bold;
        }
        .money-img {
            width: 182px;
            height: 234px;
            background-image: url('http://oss.fjdaze.com/tools/dzPopup/icon/scanbj.png');
            margin: 15px auto 0;
            padding-top: 5px;
            position: relative;
            font-size: 0;
            vertical-align: top;
            img {
                width: 167px;
                height: 167px;
                display: block;
                margin: 0 auto;
            }
            .zhifubao {
                width: 40px;
                height: 40px;
                position: absolute;
                top: 70px;
                left: 71px;
            }
        }
        .img-tip {
            position: absolute;
            width: 204px;
            height: 183px;
            right: 0;
            top: 0;
        }
    }
}
</style>
